import frLang from './entries/fr_FR';
import enLang from './entries/en-US';
import {addLocaleData} from 'react-intl';

const AppLocale = {
    fr: frLang,
    en: enLang
};
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.en.data);

export default AppLocale;



// WEBPACK FOOTER //
// ./lngProvider/index.js